// Land map palette — the single source of truth for every colour, opacity and
// line width drawn by the Land Evaluation page (LandEvaluationMap.jsx) and by
// the Atlas chat `land_map` renderer (landMapLayers.js).
//
// The values live in ./land_map_colors.json so the backend can consume the
// identical file: it is copied verbatim to
//   atlas-backend/docs/property-context/atlas-packet/land_map_colors.json
// and the server-side land_map builder reads its layer styles from there.
// Change a colour here (in the JSON), re-copy the JSON, and both maps follow.
import LAND_MAP_COLORS from './land_map_colors.json';

export { LAND_MAP_COLORS };
export default LAND_MAP_COLORS;

// Named exports used by LandEvaluationMap.jsx (same names the page used for
// its former module-level constants).
export const ANCHOR_COLOR = LAND_MAP_COLORS.anchors.color;           // anchor brands: green (the subject pin and demographics ring keep the orange)
export const ANCHOR_LABEL_COLOR = LAND_MAP_COLORS.anchors.label_color;
export const EXTERNALITY_COLOR = LAND_MAP_COLORS.adverse_uses.color;
export const PUBLIC_PLACE_COLOR = LAND_MAP_COLORS.public_places.color;       // parks & public places: blue-teal
export const PUBLIC_PLACE_LABEL_COLOR = LAND_MAP_COLORS.public_places.label_color;
export const PLACES_RING_COLOR = LAND_MAP_COLORS.places_ring.line;

export const PARCEL_COLOR = LAND_MAP_COLORS.parcel.fill;
export const PARCEL_FILL_OPACITY = LAND_MAP_COLORS.parcel.fill_opacity;
export const PARCEL_LINE_WIDTH = LAND_MAP_COLORS.parcel.width;
export const PARCEL_CASING_COLOR = LAND_MAP_COLORS.parcel.casing;
export const PARCEL_CASING_WIDTH = LAND_MAP_COLORS.parcel.casing_width;
export const PARCEL_CASING_OPACITY = LAND_MAP_COLORS.parcel.casing_opacity;

export const ZONE_COLOR = LAND_MAP_COLORS.zone.fill;
export const ZONE_FILL_OPACITY = LAND_MAP_COLORS.zone.fill_opacity;
export const ZONE_LINE_WIDTH = LAND_MAP_COLORS.zone.width;
export const ZONE_DASH = LAND_MAP_COLORS.zone.dash;
export const ZONE_LINE_OPACITY = LAND_MAP_COLORS.zone.opacity;

// Tree canopy: a darker leaf green than the anchors' green and the public
// places' blue-teal; parcel patches solid, surroundings faded.
export const CANOPY_COLOR = LAND_MAP_COLORS.canopy.fill;
export const CANOPY_PARCEL_OPACITY = LAND_MAP_COLORS.canopy.fill_opacity;
export const CANOPY_SURROUND_OPACITY = LAND_MAP_COLORS.canopy.fill_opacity_surround;

// Building footprints: slate blue — a cool hue nothing else on the map uses.
// On-parcel solid, crossing hatched, neighbours faint.
export const FOOTPRINT_COLOR = LAND_MAP_COLORS.footprints.fill;
export const FOOTPRINT_PARCEL_OPACITY = LAND_MAP_COLORS.footprints.fill_opacity;
export const FOOTPRINT_CROSSING_OPACITY = LAND_MAP_COLORS.footprints.fill_opacity_crossing;
export const FOOTPRINT_SURROUND_OPACITY = LAND_MAP_COLORS.footprints.fill_opacity_surround;

export const RADIUS_RING_COLOR = LAND_MAP_COLORS.radius_ring.line;
export const COMP_NEW_COLOR = LAND_MAP_COLORS.comps.new;            // violet = new construction
export const COMP_EXISTING_COLOR = LAND_MAP_COLORS.comps.existing;  // blue = existing (green is the anchors')
export const TERRAIN_LOW_COLOR = LAND_MAP_COLORS.terrain_points.low;
export const TERRAIN_HIGH_COLOR = LAND_MAP_COLORS.terrain_points.high;
export const SUBJECT_PIN_COLOR = LAND_MAP_COLORS.subject_pin;
export const PREVIEW_PIN_COLOR = LAND_MAP_COLORS.preview_pin;
export const POINT_STROKE_COLOR = LAND_MAP_COLORS.point.stroke;
export const LABEL_HALO_COLOR = LAND_MAP_COLORS.label.halo;

// FEMA flood zones: the backend's "flood" blue ramp (darker = more restricted),
// shared with the Site screening tile's swatches. Surroundings draw at
// `surround_opacity_scale` of the parcel opacity; base flood elevation lines dashed.
export const FLOOD_COLORS = LAND_MAP_COLORS.flood;
